import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanMatch {
  /**
   * Constructor
   */
  constructor(private _authService: AuthService, private _router: Router) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can match
   *
   * @param route
   * @param segments
   */
  canMatch(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._check(segments);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @param segments
   * @private
   */
  private _check(segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this._authService.check().pipe(
      switchMap((authenticated) => {
        if (!authenticated) {
          // Build the path (e.g. /incident-report/details)
          const path = '/' + segments.map((s) => s.path).join('/');

          // Try to get query params from the current navigation
          const nav = this._router.getCurrentNavigation();
          const queryParams = nav?.extractedUrl.queryParams || {};
          
          // Convert query params back to string
          const queryString = new URLSearchParams(queryParams).toString();

          const fullUrl = queryString ? `${path}?${queryString}` : path;

          const encodedRedirect = encodeURIComponent(fullUrl);

          // Redirect to sign-in
          const urlTree = this._router.parseUrl(
            `sign-in?redirectURL=${encodedRedirect}`
          );

          return of(urlTree);
        }

        return of(true);
      })
    );
  }
}
